import AxiosInterceptor from 'api/interceptor';

const erp = new AxiosInterceptor("http://dev-erp.subaru.w3suga.com");

export default {
    getClientToken(){
        let data = {
            grant_type: "client_credentials",
            client_id: "1",
            client_secret: "toBRsmC3ISw8hWDy1MIMHBnKEfIsB0XxKU431moI",
            scope: null
        };
        return erp.post('/oauth/token', data);
    },
    getAllProduct(){
        return erp.get('/api/stock/products');
    },
};